import React, { useState } from 'react';
import comm_imgs from './../comm_imgs';
import ApiGo_ProdKey from '../actions/ApiGo_ProdKey';


const ProdKeyPage = React.memo((props) => {
    
    const [resetValue, setResetValue] = useState("");

    return (
        <div className="fx-center h-100vh bg_radius fx-col">
            <img className="w-30"
                src={comm_imgs.LOGO_COMPANY_LOGIN}
                alt="LOGO_COMPANY_LOGIN" />
            <h1 className="m-b-5">Please enter the product key</h1>

            <input type="file"
                // value={resetValue}
                // defaultValue={resetValue}
                accept=".bin"
                onChange={(e) => {
                    // console.log('〖ProdKeyPage〗e.target.value:「', e.target.value, '」'); // C:\fakepath\encrypted_file.bin
                    e.preventDefault();
                    const form = new FormData();
                    form.append("file", e.target.files[0]);
                    ApiGo_ProdKey.rsa_decrypt(form)
                }} />
        </ div>
    )
})

export default ProdKeyPage;